<template lang="pug">
  .shaft-image(ref="root")
</template>
<script setup lang="ts">
import { computed, onMounted, useTemplateRef, watch } from 'vue'
import { renderShaftImage } from '@zeus'
import { useRogue } from '@/js/services/Rogue'

const props = defineProps<{
  options: Parameters<typeof renderShaftImage>[0],
}>()

const rogue = useRogue()
const root = useTemplateRef<HTMLElement>('root')

const renderKey = computed(() => [
  props.options.shaftImage.val,
  props.options.shaftColor.val,
].join(''))

async function update() {
  if (!root.value) {
    return
  }

  const el = root.value.children?.[0] as HTMLElement | undefined
  const { svg } = await renderShaftImage(props.options, document, rogue.fetch.bind(rogue), el)

  if (!root.value.children.length) {
    root.value.appendChild(svg)
  }
}

watch(renderKey, () => {
  if (root.value) {
    update()
  }
})

onMounted(() => {
  setTimeout(() => update(), 100)
})
</script>
